import { createSlice } from '@reduxjs/toolkit';
import { list } from '../api/actions/query';

const initialState = {
    booking: [],
    error: null,
};

const bookingSlice = createSlice({
    name: 'bookings',
    initialState,
    reducers: {
        setBooking: (state, action) => {
            state.booking = action.payload;
        },
        setFailed: (state, action) => {
            state.error = action.payload;
        }
    },
});

export const fetchAllBookings = () => async (dispatch) => {
    try {
        const response = await list();
        dispatch(setBooking(response));
    } catch (error) {
        dispatch(setFailed(error.message));
    }
};


export const { setBooking, setFailed } = bookingSlice.actions;
export default bookingSlice.reducer;
